import React from 'react'
import { menLevelThree } from '../../../data/category/level three/menLevelThree'
import { menLevelTwo } from '../../../data/category/level two/menLevelTwo'
import { womenLevelThree } from '../../../data/category/level three/womenLevelThree'
import { womenLevelTwo } from '../../../data/category/level two/womenLevelTwo'
import { jewelleryBeadsLevelTwo } from '../../../data/category/level two/jewelleryBeadsLevelTwo'
import { jewelleryFindingsLevelTwo } from '../../../data/category/level two/jewelleryFindingsLevelTwo'

import { spiritualMaalaLevelTwo } from "../../../data/category/level two/spiritualMaalaLevelTwo";
import { toolsSuppliesLevelTwo } from "../../../data/category/level two/toolsSuppliesLevelTwo";
import { packingSuppliesLevelTwo } from "../../../data/category/level two/packingSuppliesLevelTwo";
import { beadingThreadWiresLevelTwo } from "../../../data/category/level two/beadingThreadWiresLevelTwo"

import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { electronicsLevelTwo } from '../../../data/category/level two/electronicsLavelTwo'
import { furnitureLevelTwo } from '../../../data/category/level two/furnitureLevleTwo'
import { furnitureLevelThree } from '../../../data/category/level three/furnitureLevelThree'
import { electronicsLevelThree } from '../../../data/category/level three/electronicsLevelThree'
import { jewelleryBeadsLevelThree } from '../../../data/category/level three/jewelleryBeadsLevelThree'
import { jewelleryFindingsLevelThree } from "../../../data/category/level three/jewelleryFindingsLevelThree";
import { toolsSuppliesLevelThree } from '../../../data/category/level three/toolsSuppliesLevelThree'
import { packingSuppliesLevelThree } from "../../../data/category/level three/packingSuppliesLevelThree";
import { spiritualMaalaLevelThree } from "../../../data/category/level three/spiritualMaalaLevelThree";
import { beadingThreadWiresLevelThree } from "../../../data/category/level three/beadingThreadWiresLevelThree";



const categoryTwo: { [key: string]: any[] } = {

    men: menLevelTwo,
    women: womenLevelTwo,
    electronics: electronicsLevelTwo,
    home_furniture: furnitureLevelTwo,
    jewellery_beads: jewelleryBeadsLevelTwo,
    jewellery_findings: jewelleryFindingsLevelTwo,
    spiritual_maala: spiritualMaalaLevelTwo,
    tools_n_supplies: toolsSuppliesLevelTwo,
    packing_n_supplies: packingSuppliesLevelTwo,
    beading_thread_n_wires: beadingThreadWiresLevelTwo


}

const categoryThree: { [key: string]: any[] } = {
    men: menLevelThree,
    women: womenLevelThree,
    electronics: electronicsLevelThree,
    home_furniture: furnitureLevelThree,
    jewellery_beads: jewelleryBeadsLevelThree,
    tools_n_supplies: toolsSuppliesLevelThree,
    packing_n_supplies: packingSuppliesLevelThree,
    jewellery_findings: jewelleryFindingsLevelThree,
    spiritual_maala: spiritualMaalaLevelThree,
    beading_thread_n_wires: beadingThreadWiresLevelThree

}

const CategorySheet = ({ selectedCategory, toggleDrawer, setShowSheet }: any) => {

    const navigate = useNavigate()


    const childCategory = (category: any, parentCategoryId: any) => {
        return category.filter((child: any) => {
            return child.parentCategoryId == parentCategoryId
        })

    }
    const handleCategoryClick = (category: string) => {
        if (toggleDrawer) {
            toggleDrawer(false)()
        }
        if (setShowSheet) {
            setShowSheet(false)
        }

        navigate("/products/" + category)
    }
    return (
        <Box className='bg-white shadow-lg  lg:h-[500px] overflow-y-auto'>
            <div className=' flex text-sm flex-wrap'>
                {categoryTwo[selectedCategory]?.map((item: any, index) =>
                    <div key={item.name} className={`p-8 lg:w-[20%] ${index % 2 == 0 ? "bg-slate-50" : "bg-white"}`}>

                        <p className='text-[#00927c] mb-5 font-semibold'>{item.name}</p>

                        <ul className='space-y-3'>
                            {childCategory(categoryThree[selectedCategory], item.categoryId)?.map((item: any) => <div key={item.name}>

                                <li
                                    onClick={() => handleCategoryClick(item.categoryId)}
                                    className='hover:text-[#00927c] cursor-pointer'>
                                    {item.name}
                                </li>

                            </div>)}
                        </ul>


                    </div>)}
            </div>
        </Box>
    )
}

export default CategorySheet